import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './link.magic.css.js';
import script from './link.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.button && _vm.to)?_c('magic-ui-button',_vm._b({attrs:{"button-tag":"magic-router-link"},domProps:{"to":_vm.to},on:{"click":function($event){return _vm.clicked()}}},'magic-ui-button',_vm.$attrs,false),[_vm._t("default")],2):(_vm.to)?_c('magic-router-link',_vm._b({staticClass:"router-link",attrs:{"data-v-test-id":((_vm.$attrs['data-v-test-id']) + "-a"),"to":_vm.to}},'magic-router-link',_vm.$attrs,false),[_vm._t("default")],2):_c('a',_vm._b({staticClass:"link",class:{
        'is-disabled': _vm.disabled,
        'link--bold': _vm.bold,
    },attrs:{"part":_vm.$p('link', {
        'is-disabled': _vm.disabled,
        'link--bold': _vm.bold,
    })},on:{"click":function($event){return _vm.clicked()}}},'a',_vm.$attrs,false),[_vm._t("default")],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-42e2a626_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-42e2a626";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
